import './playground.scss';

import { defineComponent } from 'vue';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

import { CommonRoutes } from '@skinsoft/const';
import { fetch, FetchError, Proxy } from '@skinsoft/network';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { UserAuthenticatedResult } from '@skinsoft/auth';
import { OfflineRibbon, ServiceWorkerLifecycle } from '@skinsoft/offline-mode';
import { Navbar, SideMenu } from '@skinsoft/ui';
import { TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics';
import { initLanguages } from '@skinsoft/init';

import { FORCE_CLOSE_MENU_TOPIC } from '../../../busTopics'
import { router } from '../../../router';
import { AlertContainer } from '../../report-edition/alert-container';
import { ActionBar } from '../action-bar';
import { ReportMenu } from '../report-menu';

export const Playground = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sActionBar: ActionBar,
        sAlertContainer: AlertContainer,
        sNavbar: Navbar,
        sOfflineRibbon: OfflineRibbon,
        sReportMenu: ReportMenu,
        sServiceWorkerLifecycle: ServiceWorkerLifecycle,
        sSideMenu: SideMenu
    },
    props: {
        embeddedMode: {
            type: Boolean,
            default: false,
        },
    },
    template: require('./playground.html'),
    data() {
        return {
            ready: false,
            loadingIcon: faCircleNotch,
            slowNetwork: false,
            hasContextMenu: false,
            toggleSideMenuTopic: TOGGLE_MENU_TOPIC,
            forceCloseMenuTopic: FORCE_CLOSE_MENU_TOPIC,
            error$: new Subject<FetchError>(),
        }
    },
    async created() {
        let timeoutId: NodeJS.Timer | null;

        timeoutId = setTimeout(() => {
            this.slowNetwork = true;
            timeoutId = null;
        }, 10e3);

        if (timeoutId) {
            // @ts-ignore
            clearTimeout(timeoutId);
        }

        Proxy.onError(error => this.error$.next(error));
        this.subscribeTo(this.error$.pipe(throttleTime(100)), this.onProxyError);
        this.ready = true;
    },
    mounted() {
        this.subscribeTo(this.$authService.waitForUser$(), this.onUser);
    },
    methods: {
        onUser(userAuthResult: UserAuthenticatedResult | null) {
            if (userAuthResult?.user) {
                initLanguages()
                return
            }

            if (router.currentRoute.value.name !== CommonRoutes.LOGIN) {
                router.push({ name: CommonRoutes.LOGIN });
            }
        },
        onProxyError(error: FetchError) {
            let message: string;

            switch (error.status) {
                case 404:
                    message = this.$t('proxy.error.notFound', { uri: error.uri }) as string;
                    break;
                case 401:
                    if (router.currentRoute.value.name === CommonRoutes.LOGIN) {
                        return;
                    }

                    this.$authService.logOut();
                    message = this.$t('proxy.error.tokenHasExpired') as string;
                    break;
                default:
                    if (fetch.isNetworkError(error)) {
                        if (!window.navigator.onLine) {
                            return;
                        }
                        message = this.$t('proxy.error.network') as string;
                    } else {
                        return;
                    }
                    break;
            }

            this.$toasted.show(message, {
                action: [
                    {
                        onClick: (_, toastObject) => {
                            toastObject.goAway(0);
                        },
                        text: 'Fermer',
                    },
                ],
                duration: 3e3,
                fitToScreen: true,
                fullWidth: true,
                position: 'bottom-center',
                singleton: true,
            });
        },
    },
})
